<template>
    <div>
        <div class="g-group">
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="baseDraw('ecavationCalc')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="a-excavation" /></div>
                            <div class="title">挖方计算</div>
                        </div>
                        <div @click="baseDraw('slopeAnalysis')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="a-slope" /></div>
                            <div class="title">坡度坡向</div>
                        </div>
                        <div @click="crossSection" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="a-section" /></div>
                            <div class="title">剖面分析</div>
                        </div>
                    </div>
                    <div class="text">
                        地形分析
                    </div>
                </div>
            </div>
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="baseDraw('intervisibilePoint')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="a-two-point" /></div>
                            <div class="title">俩点通视</div>
                        </div>
                        <div @click="baseDraw('intervisibileCircle')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="a-circle-view" /></div>
                            <div class="title">圆形通视</div>
                        </div>
                        <!-- <div @click="baseDraw('viewShedAnalysis')" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="s-dis-t" /></div>
                            <div class="title">可视域</div>
                        </div> -->

                    </div>
                    <div class="text">
                        可视分析
                    </div>
                </div>
            </div>
            <div class="f-group">
                <div class="inner">
                    <div class="list">
                        <div @click="clear()" class="item">
                            <div class="logo"><svg-icon class="icon" icon-class="p-clear" /></div>
                            <div class="title">清除</div>
                        </div>
                    </div>
                    <div class="text">
                        操作
                    </div>
                </div>
            </div>
        </div>
        <div class="g-msg">提示:鼠标左键取点，右键结束绘制。</div>
    </div>
</template>

<script>
import AnalysisManage from "@/utils/cesiumBD/analysis/AnalysisManage.js";
import CrossSection from "@/utils/cesiumBD/analysis/CrossSection.js";
let analysisUti = undefined;
let crossSectionUti = undefined
import CrossSectionCom from "../CrossSection/index.vue"
export default {
    data() {
        return {

        };
    },

    mounted() {
        document.oncontextmenu=new Function("return false");
    },

    methods: {
        crossSection() {
            let that=this;
            let loadingIns=undefined;
            if (!crossSectionUti) {
                crossSectionUti = new CrossSection({
                    canEdit: false,
                    analysisStart: () => {
                        loadingIns = that.$loading({
                            lock: true,
                            text: '正在分析,请稍后...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                    },
                    analysisDone: (xData, yData) => {
                        loadingIns.close();
                        loadingIns=undefined;
                        this.$dialog.open({
                            title: "剖面分析",
                            area: {
                                height: "260px",
                                width: "100vw",
                            },
                            location: {
                                bottom: "40px",
                                right: "0px"
                            },
                            content: {
                                type: "vue",
                                subCom: CrossSectionCom,
                                subData: {
                                    xData: xData,
                                    yData: yData
                                }
                            },
                        });
                    }
                });
            }
            crossSectionUti.reset();
            crossSectionUti.start();
        },
        baseDraw(type) {
            let that=this;
            let loadingIns=undefined;

            if (!analysisUti) {
                analysisUti = new AnalysisManage({
                    canEdit: true,
                    analysisStart: () => {
                        loadingIns = that.$loading({
                            lock: true,
                            text: '正在分析,请稍后...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                    },
                    analysisDone: () => {
                        loadingIns.close();
                        loadingIns=undefined;
                    }
                });
            }
            analysisUti.start(type);
        },

        clear() {
            analysisUti && analysisUti.clear();
            crossSectionUti && crossSectionUti.clear();
        },
    },
};
</script>

<style lang="scss" scoped>
.g-group {
    display: flex;
    flex-direction: row;
}

.g-msg {
    color: #E6A23C;
    font-size: 12px;
    padding: 4px 0 0 10px;
}

.f-group {
    color: #FFFFFF;
    font-size: 12px;
    flex: auto;

    .inner {
        border-right: 1px solid rgba(#FFFFFF, 0.2);

        .list {
            display: flex;

            .item {
                flex: auto;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                cursor: pointer;

                .icon {
                    width: 20px;
                    height: 20px;
                }
            }
        }

        .text {
            text-align: center;
            padding-top: 5px;
        }
    }
}
</style>